/** @format */

import React, { useState } from 'react';
import styles from './contacts.module.css';
import classNames from 'classnames';
import { addGuestDetails } from '../../../../services/home.service';
import useAppContext from '../../../hooks/useAppContext';
import batmanImage from '../../../../assets/batman.png';
function Contacts() {
  return (
    <section className={classNames(styles['contacts-container'])}>
      <GuestDetails />
      <div className={classNames(styles['contacts-wrapper'])}>
        <h3 className={classNames(styles['contact-us'])}>Contact Me</h3>
        <div className={classNames(styles['contact-info'])}>
          <p className={classNames(styles['info-item'])}>
            Email:{' '}
            <a
              href="mailto:ykakde3@gmail.com"
              className={classNames(styles['link'])}
            >
              ykakde3@gmail.com
            </a>
          </p>
          <p className={classNames(styles['info-item'])}>
            Phone:{' '}
            <a href="tel:+918554855887" className={classNames(styles['link'])}>
              8554855887
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}

function GuestDetails() {
  const [form, setForm] = useState({ name: '', contact: '', message: '' });
  const { uuid, handleUUID } = useAppContext();

  function handleSend() {
    const name = form.name.trim();
    const contact = form.contact.trim();
    if (name && contact) {
      addGuestDetails({ ...form, uuid: uuid || handleUUID() });
      setForm({ name: '', contact: '', message: '' });
      alert('Thank you for your message! I will get back to you soon.');
    }
  }
  return (
    <form action="#" onSubmit={(ev) => ev.preventDefault()}>
      <div className={classNames(styles['guest-details'])}>
        <div style={{ textAlign: 'center' }}>
          <img
            alt="batman logo"
            src={batmanImage}
            className={styles['batman-img']}
          ></img>
        </div>
        <input
          value={form.name}
          onChange={(ev) => setForm({ ...form, name: ev.target.value })}
          required
          placeholder="your name  (required)"
        ></input>
        <input
          value={form.contact}
          onChange={(ev) => setForm({ ...form, contact: ev.target.value })}
          required
          placeholder="email or mobile (required)"
        ></input>
        <textarea
          rows="7"
          value={form.message}
          onChange={(ev) => setForm({ ...form, message: ev.target.value })}
          required
          placeholder="(optional) Any message?"
        ></textarea>
        <button type="submit" onClick={() => handleSend()}>
          Send
        </button>
      </div>
    </form>
  );
}

export default Contacts;
